import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentIconGroupComponent } from './component-icon-group.component';



@NgModule({
  declarations: [
    ComponentIconGroupComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ComponentIconGroupComponent
  ]
})
export class ComponentIconGroupModule { }
